import { Close, Search as SearchIcon } from '@carbon/icons-react';
import { CdIconButton } from '../../atoms/CdIconButton';
import { CdText } from '../../atoms/CdTypography';
import { CdSearchField } from '../CdSearchField';
import styles from './CdSearchWithRecent.module.scss';

export interface CdSearchWithRecentProps {
  label: string;
  placeholder?: string;
  value: string;
  onValueChange: (value: string) => void;
  onSubmit?: (value: string) => void;
  recent: string[];
  recentTitle?: string;
  onClose: () => void;
}

/** Full-screen mobile search with recent searches (Figma "Mobile – Search"). */
export const CdSearchWithRecent = ({
  label,
  placeholder,
  value,
  onValueChange,
  onSubmit,
  recent,
  recentTitle = 'Recent searches',
  onClose,
}: CdSearchWithRecentProps) => {
  return (
    <div className={styles.root}>
      <form
        className={styles.bar}
        role="search"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.(value);
        }}
      >
        <CdSearchField
          label={label}
          placeholder={placeholder}
          value={value}
          onValueChange={onValueChange}
          // The overlay is opened explicitly by the user, so focusing the field is expected.
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
        />
        <CdIconButton label="Close search" icon={Close} onClick={onClose} />
      </form>
      {recent.length > 0 && (
        <section className={styles.recent} aria-label={recentTitle}>
          <CdText variant="label" tone="secondary" className={styles.recentTitle}>
            {recentTitle}
          </CdText>
          <ul className={styles.list}>
            {recent.map((item) => (
              <li key={item}>
                <button
                  type="button"
                  className={styles.item}
                  onClick={() => {
                    onValueChange(item);
                    onSubmit?.(item);
                  }}
                >
                  <SearchIcon aria-hidden="true" />
                  <span>{item}</span>
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
};
